const rawApiBase = process.env.REACT_APP_API_URL || 'https://api.winewar.wine';

export const API_BASE = (() => {
  // If the site is running on the public kevinofoy.com hostname, force
  // the backend to the Render origin so requests don't get routed to
  // the wrong upstream when the site is served via a third-party host.
  try {
    if (typeof window !== 'undefined' && window.location.hostname === 'winewar.wine') {
      return 'https://api.winewar.wine';
    }
  } catch (e) {
    // ignore
  }

  const trimmed = String(rawApiBase).replace(/\/$/, '');
  try {
    if (typeof window === 'undefined') return trimmed;
    const url = new URL(trimmed, window.location.origin);
    // If the configured URL resolves to the same origin, prefer a same-origin path
    if (url.origin === window.location.origin) {
      return (url.pathname || '/api').replace(/\/$/, '') || '/api';
    }
    return url.href.replace(/\/$/, '');
  } catch (e) {
    return trimmed;
  }
})();

export function api(path: string) {
  if (!path.startsWith('/')) path = `/${path}`;
  // Only strip a leading `/api` when the configured API base is the
  // default `/api`. If `REACT_APP_API_URL` points to a full backend URL
  // (e.g. http://localhost:5003 or http://localhost:5003/api), preserve
  // the `/api` segment so requests reach the mounted backend routes.
  const base = String(API_BASE).replace(/\/$/, '');
  if (base === '/api') {
    path = path.replace(/^\/api(?=\/|$)/, '');
  }

  return `${base}${path}`;
}

export default api;
